export default "__VITE_ASSET__DwVs7W0G__"